/* Pawfolk Theme — theme.js */
document.addEventListener('DOMContentLoaded', () => {

  // Wishlist toggle
  document.querySelectorAll('.product-card__wishlist').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.textContent = btn.textContent.trim() === '🤍' ? '❤️' : '🤍';
    });
  });

  // Newsletter form
  const nlForm = document.querySelector('.newsletter-block__form');
  if (nlForm) {
    nlForm.addEventListener('submit', e => {
      e.preventDefault();
      const input = nlForm.querySelector('input[type="email"]');
      const note  = nlForm.closest('.newsletter-block').querySelector('.newsletter-block__note');
      if (!input || !input.value.trim()) return;
      input.value = '';
      if (note) {
        note.textContent = '🎉 You\'re in! Check your inbox for your $10 coupon.';
        note.style.color = 'var(--color-green)';
        note.style.fontWeight = '600';
      }
    });
  }

  // Cart count (connect to Shopify cart API)
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badge = document.querySelector('.cart-badge');
      if (badge) badge.textContent = cart.item_count || 0;
    })
    .catch(() => {});

  // Smooth mobile menu (toggle class)
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded',
        menuToggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
      );
    });
  }

});
